import axios from "axios";
import authHeader from './services/AuthHeader';

let headers = authHeader();
headers["Content-type"] = "application/json";
let baseURL;
if (process.env.NODE_ENV === "development") {
    baseURL = "http://localhost:8888";
} else {
    baseURL = "/api";
}

export default axios.create({
    baseURL: baseURL,
    headers: headers,
});
